// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"c47fea45","324":"3c65ddda","339":"ce7a0fb2","382":"79e16a29","453":"57efe4b5","496":"3cf0dd49","791":"718155a8","943":"b326dead","950":"966550c6"}[chunkId] + ".chunk.js";
};